"use client";
import { jsxs as h, jsx as e } from "react/jsx-runtime";
import { cva as s } from "class-variance-authority";
import { useState as x } from "react";
import { Close as g } from "@videoblocks/react-icons";
import { cn as a } from "./index.es14.js";
import { Text as w } from "./index.es4.js";
const b = s("flex justify-center items-center", {
  variants: {
    size: {
      small: "px-1.5 py-0.5",
      medium: "px-1.5 py-0.5",
      large: "px-2 py-1.5"
    },
    color: {
      // include colors for hover state when theres a close button, work with design
      neutral: "bg-white text-gray-900",
      info: "bg-blue-700 text-white",
      success: "bg-green-700 text-white",
      warning: "bg-pink-700 text-white"
    },
    shape: {
      rounded: "rounded-full",
      square: "rounded"
    }
  },
  defaultVariants: {
    size: "small",
    color: "info"
  }
}), y = s("fill-current", {
  variants: {
    size: {
      small: "w-2.5 h-2.5",
      medium: "w-3.5 h-3.5",
      large: "w-4 h-4"
    }
  }
}), z = s("", {
  variants: {
    textCase: {
      capitalize: "capitalize",
      uppercase: "uppercase",
      lowercase: "lowercase"
    }
  }
}), q = ({
  className: i,
  color: l = "info",
  hasCloseButton: n = !1,
  Icon: r = null,
  shape: o = "square",
  size: t = "medium",
  text: c = "New",
  textCase: p = "capitalize",
  fontWeight: m = "regular"
}) => {
  const [u, d] = x(!0), f = {
    small: "xs",
    medium: "sm",
    large: "base"
  }[t] || "base";
  return u ? /* @__PURE__ */ h("div", { className: a(b({ size: t, color: l, shape: o }), "gap-1", i), children: [
    r && /* @__PURE__ */ e(r, { className: a(y({ size: t })) }),
    /* @__PURE__ */ e(w, { asChild: !0, fontWeight: m, fontSize: f, className: a(z({ textCase: p })), children: /* @__PURE__ */ e("span", { children: c }) }),
    n ? /* @__PURE__ */ e(
      "button",
      {
        style: t === "small" ? { width: "6px", height: "6px" } : { width: "8px", height: "8px" },
        onClick: () => d(!1),
        children: /* @__PURE__ */ e(g, { className: "block fill-current" })
      }
    ) : null
  ] }) : null;
};
export {
  q as Badge,
  b as badgeVariants
};
